import { render, staticRenderFns } from "./lab-test-platform-list.vue?vue&type=template&id=c0e2be04&"
import script from "./lab-test-platform-list.vue?vue&type=script&lang=js&"
export * from "./lab-test-platform-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports